'use strict';

// COMPONENTS
// -----------
import * as nouislider from '../node_modules/no-ui-slider/lib/nouislider.js';
window.noUiSlider = nouislider;
import angular from "angular";
import socialshare from "angular-socialshare";
import angularCookies from "angular-cookies";
import owlCarousel from "../node_modules/owl.carousel/dist/owl.carousel.js";
import noUiSliderAngular from "nouislider-angular";
import pikadayAngular from "pikaday-angular";

import {BodyController} from "../components/BodyController/BodyController"
import {glHeader} from "../components/gl-header/gl-header";
import {glFooter} from "../components/gl-footer/gl-footer";
import {property, floorplan, galleryFilter} from "../components/property/property";
import {lightbox} from "../components/lightbox/lightbox";
import {expander} from "../components/expander/expander";
import {compareTool} from "../components/compare-tool/compare-tool";
import {questionCard} from "../components/question-card/question-card"; // is this used?
import {modalFactory, closeModal, modalCallback} from "../components/modal/modalFactory";
import {mainNavToggle} from "../components/main-nav/main-nav";
import {propertySearch, PropertySearchController, SearchResults} from "../components/property-search/property-search";
import {propertyMap} from "../components/maps/maps";
import {locationMap} from "../components/location-map/location-map";
import {FloorplanSmsFormController} from "../components/modal/FloorplanSmsFormController";
import {ResidentsFeedbackController} from "../components/modal/ResidentsFeedbackController";
import {propertyTeam} from "../components/property/property-team";
import {propertyNavbar} from "../components/property/property-navbar";
import {propertyHero} from "../components/property/property-hero";
import {propertySpecials} from "../components/property/property-page-specials";
import {propertyPageGallery} from "../components/property/property-page-gallery";
import {propertyPageFloorplans} from "../components/property/property-page-floorplans";
import {walkScore} from "../components/property/property-location";
import {ContactPage} from "../components/contact-page/contact-page";
import {sticky} from "../components/sticky/sticky";
import {slider} from "../components/slider/slider";
import propertiesSlider from "../components/property/properties-slider";
import {propertyTestimonials} from "../components/property/property-testimonials";

propertiesSlider();
expander();
questionCard();
mainNavToggle();

let app = angular.module('richman_app', ['720kb.socialshare', 'ngCookies', 'ya.nouislider', 'pikaday'])
    .config(['pikadayConfigProvider', function(pikaday) {
        pikaday.setConfig({
            minDate: new Date()
        });
    }])
    .config(['$locationProvider', function($locationProvider) {
        $locationProvider.html5Mode({ enabled: true, requireBase: false, rewriteLinks: false });
    }])
    .factory('modalFactory', modalFactory)
    .factory('compareTool', compareTool)

    .directive('glHeader', glHeader)
    .directive('glFooter', glFooter)
    .directive('property', property)
    .directive('floorplan', floorplan)
    .directive('galleryFilter', galleryFilter)
    .directive('closeModal', closeModal)
    .directive('modalCallback', modalCallback)
    .directive('lightbox', lightbox)
    .directive('propertySearch', propertySearch)
    .directive('propertyMap', propertyMap)
    .directive('locationMap', locationMap)
    .directive('sticky', sticky)
    .directive('slider', slider)
    .directive('walkScore', walkScore)

    .controller('BodyController', BodyController)
    .controller('PropertySearchController', PropertySearchController)
    .controller('FloorplanSmsFormController', FloorplanSmsFormController)
    .controller('ResidentsFeedbackController', ResidentsFeedbackController)
    .controller('SearchResults', SearchResults)
    .controller('propertyTeam', propertyTeam)
    .controller('propertyNavbar', propertyNavbar)
    .controller('propertyHero', propertyHero)
    .controller('propertySpecials', propertySpecials)
    .controller('propertyPageGallery', propertyPageGallery)
    .controller('propertyPageFloorplans', propertyPageFloorplans)
    .controller('ContactPage', ContactPage)
    .controller('propertyTestimonials', propertyTestimonials)
